@if (loading()) {
  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
}
@if (!loading()) {
  @if (products() && products()!.length > 0 && datasource()) {
    <se-fe-table-wrapper class="product-list-table-wrapper">
      <table
        seFeTable
        title="Products in bundle table"
        style="max-height: 400px"
        class="product-list-table"
        [dataSource]="datasource()">
        <ng-container seFeColumnDef="Name">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef>Product Name</th>
          <td class="table-row" seFeCell *seFeCellDef="let row">
            <product-name-cell [product]="row" [link]="getProductLink(row)" target="_blank"></product-name-cell>
          </td>
        </ng-container>
        <ng-container seFeColumnDef="Price">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef>Price</th>
          <td class="table-row" seFeCell *seFeCellDef="let row">
            <product-price-cell [price]="row.price"></product-price-cell>
          </td>
        </ng-container>
        <ng-container seFeColumnDef="Bundled Price">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef>Bundled Price</th>
          <td class="table-row" seFeCell *seFeCellDef="let row">
            <product-price-cell [price]="row.bundledPrice"></product-price-cell>
          </td>
        </ng-container>
        <ng-container seFeColumnDef="Active">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef>Status</th>
          <td class="statusColumn" seFeCell *seFeCellDef="let row">
            <product-status-cell [product]="row"></product-status-cell>
          </td>
        </ng-container>
        <ng-container seFeColumnDef="Delete">
          <th seFeHeaderCell *seFeHeaderCellDef></th>
          <td seFeCell *seFeCellDef="let row">
            <se-fe-button
              (click)="removeFromBundle.emit(row)"
              seFeDataEmphasis="low"
              [seFeDataButtonAttrs]="{'aria-label': 'Remove product from bundle'}">
              Remove
            </se-fe-button>
          </td>
        </ng-container>
        <tr seFeHeaderRow *seFeHeaderRowDef="displayedColumns()"></tr>
        <tr [seFeRow]="row" *seFeRowDef="let row; columns: displayedColumns()"></tr>
      </table>
    </se-fe-table-wrapper>
  } @else {
    <se-fe-empty-state class="empty-state" seFeDataTitle="No products found"></se-fe-empty-state>
  }
}
